import { DateTime } from "luxon"

import { getLocations } from "@/api/getLocations"

import { downloadKPIExport } from "./downloadKPIExport"
import { getKPIExportData } from "./getKPIExportData"

export const exportKPIs = async (location: number, start: Date, end: Date) => {
  const data = await getKPIExportData(location, start, end)
  const locations = await getLocations()

  const locName = locations.find((l) => l.id == location)?.name || ""
  const startString = DateTime.fromJSDate(start).toISODate() || ""
  const endString = DateTime.fromJSDate(end).toISODate() || ""
  const filename = locName + "_KPIs_" + startString + "_" + endString

  downloadKPIExport(data, filename)
}
